export const getVenueWorkoutTypeTrainingPrograms = (state) => () => {
  return state.venueTrainingPrograms
}

export const getTrainingWorkoutTypeTrainingPrograms = (state) => () => {
  return state.trainingTrainingPrograms
}
